import type { FormInputType } from 'components/technical/form/Form.types.ts';
import { type PortfolioStepOutput, schema as portfolioStepSchema } from './PortfoliosStep.validation.tsx';
import { type ShockStepOutput, schema as shockStepSchema } from './ModelAndAssumptionsStep.validation.tsx';

export type UnifiedStressTestOutputFields = PortfolioStepOutput & ShockStepOutput;

export type UnifiedStressTestInputFields = FormInputType<PortfolioStepOutput> & FormInputType<ShockStepOutput>;

export const schema = portfolioStepSchema.concat(shockStepSchema);
